
/*
 * Opens a youtube page 
 */
function rick() {
  // window.open("https://www.youtube.com/watch?v=dQw4w9WgXcQ&list=RDdQw4w9WgXcQ&start_radio=1");
  window.open("https://youtu.be/dQw4w9WgXcQ?si=Py74gmyjBmMdR4au&t=1?autoplay=1&mute=1 ");
}

export default rick;
